export const BDXMatchPendingManagerInjectionKey = 'bdx-match-pending-manager'
